<!--
  @component CuentaMedicaLayout
  @description Layout del módulo Cuenta Médica con tabs Transacciones / Liquidaciones
-->
<template>
  <div class="cm-layout">
    <div class="cm-layout__tabs">
      <router-link
        :to="{ name: 'service-record-list' }"
        class="cm-layout__tab"
        :class="{ 'is-active': $route.name === 'service-record-list' }"
      >
        Transacciones
      </router-link>
      <!--
        UC-REG-177 — Tab "Liquidaciones" (flujo A viejo) OCULTO. Submissions
        es el flujo canónico. La ruta /liquidations sigue accesible por URL
        directa por si hay que consultar histórico read-only, pero no se
        muestra en el tab bar. Descomentar el bloque para reactivar.
      -->
      <!-- <router-link
        :to="{ name: 'liquidation-list' }"
        class="cm-layout__tab"
        :class="{ 'is-active': $route.name === 'liquidation-list' }"
      >
        Liquidaciones
      </router-link> -->
      <router-link
        :to="{ name: 'liquidation-submission-list' }"
        class="cm-layout__tab"
        :class="{ 'is-active': isSubmissionRoute }"
      >
        Liquidaciones
      </router-link>
      <!-- UC-REG-217 — Tab resumen por prestador -->
      <router-link
        :to="{ name: 'provider-summary' }"
        class="cm-layout__tab"
        :class="{ 'is-active': $route.name === 'provider-summary' }"
      >
        Por prestador
      </router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
/**
 * @component CuentaMedicaLayout
 * @description Layout con tabs para Cuenta Médica. El título del topbar
 * se maneja vía ROUTE_TITLES en Main.vue.
 */
export default {
  name: "CuentaMedicaLayout",
  computed: {
    /**
     * @returns {boolean} true si la ruta activa es alguna del flujo B
     *   (submissions — listado / nueva / detalle)
     */
    isSubmissionRoute() {
      return (this.$route.name || "").startsWith("liquidation-submission");
    },
  },
};
</script>

<style scoped>
.cm-layout {
  font-family: "Plus Jakarta Sans", sans-serif;
}

.cm-layout__tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0;
}

.cm-layout__tab {
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #6b7294;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;
}

.cm-layout__tab:hover {
  color: #002d5e;
}

.cm-layout__tab.is-active {
  color: #002d5e;
  border-bottom-color: #002d5e;
}
</style>
